<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="pedidos"
      :options.sync="options"
      class="elevation-1"
      :sort-by="'created_at'"
      :sort-desc="true"
      :loading="loading"
      :server-items-length="pedidosTotal"
      :footer-props="{ itemsPerPageOptions: itemsPerPageOptions }"
      @update:options="listar"
    >
      <template v-slot:item.id="{ item }">
        {{ $_str_pad_left(item.id) }}
      </template>
      <template v-slot:item.subtotal="{ item }">
        {{ $_currency(item.subtotal, true) }}
      </template>
      <template v-slot:item.envio="{ item }">
        <v-badge
          :content="item.envios.length"
          :value="item.envios.length > 1"
          color="green"
        >
          {{ $_currency(item.envio) }}
        </v-badge>
      </template>
      <template v-slot:item.total="{ item }">
        {{ $_currency(item.total, true) }}
      </template>
      <template v-slot:item.pagado="{ item }">
        <v-badge
          color="green"
          :value="item.pagos.length > 1"
          :content="item.pagos.length"
          overlap
        >
          <v-btn text small @click="showPayments(item)">{{
            $_currency(item.pagado, true)
          }}</v-btn>
        </v-badge>
      </template>
      <template v-slot:item.total_recompensas="{ item }">
        {{ $_currency(item.total_recompensas, true) }}
      </template>
      <template v-slot:item.tags="{ item }">
        <v-chip v-for="(tag, index) in item.tags" :key="tag.name + index">{{
          tag.name.es
        }}</v-chip>
      </template>
      <!-- <template v-slot:item.monto_recompensa="{item}">
                {{ $_currency(item.monto_recompensa) }}
            </template>
            <template v-slot:item.update_at="{item}">
                {{ formatUpdateAt(item.updated_at) }}
            </template> -->
      <template v-slot:body.append="props">
        <tr>
          <td colspan="4" class="text-right">Total página:</td>
          <td class="text-right font-weight-bold">
            {{ $_currency(montoSubtotalPorPagina, true) }}
          </td>
          <td class="text-right font-weight-bold">
            {{ $_currency(montoTotalEnvioPagina, true) }}
          </td>
          <td class="text-right font-weight-bold">
            {{ $_currency(montoTotalPorPagina, true) }}
          </td>
          <td class="text-right font-weight-bold">
            {{ $_currency(montoTotalPagadoPorPagina, true) }}
          </td>
          <td class="text-right font-weight-bold"></td>
          <!-- <td class="text-right font-weight-bold">{{$_currency(montoTotalRecompensaPagina, true)}}</td> -->
        </tr>
        <tr>
          <td colspan="4" class="text-right">
            Total filtrado ({{ pedidosTotal }}):
          </td>
          <td class="text-right font-weight-bold">
            {{ $_currency(montoSubtotalGlobal, true) }}
          </td>
          <td class="text-right font-weight-bold">
            {{ $_currency(montoTotalEnvioGlobal, true) }}
          </td>
          <td class="text-right font-weight-bold">
            {{ $_currency(montoTotalGlobal, true) }}
          </td>
          <td class="text-right font-weight-bold">
            {{ $_currency(montoTotalPagadoGlobal, true) }}
          </td>
          <td class="text-right font-weight-bold"></td>
          <!-- <td class="text-right font-weight-bold">{{$_currency(montoTotalRecompensaPagina, true)}}</td> -->
        </tr>
      </template>
    </v-data-table>
    <v-dialog v-model="dialogPayments" max-width="600">
      <v-card>
        <v-card-title class="headline">Pagos</v-card-title>

        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Fecha</th>
                  <th class="text-left">Método</th>
                  <th class="text-left">Monto</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="pago in pedido_selected.pagos" :key="pago.id">
                  <td>{{ pago.created_at }}</td>
                  <td class="text-capitalize">{{ pago.forma_pago }}</td>
                  <td class="text-right">{{ $_currency(pago.monto, true) }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn @click="dialogPayments = false"> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  name: "RecompensaPorPedido",
  props: {
    filter: {
      type: Object,
      default: () => {
        return {
          desde: null,
          hasta: null,
        };
      },
    },
  },
  data() {
    return {
      descending: true,
      sortBy: "created_at",
      headers: [
        {
          text: "Nº Pedido",
          align: "center",
          sortable: false,
          value: "id",
          width: "150px",
        },
        {
          text: "Fecha alta",
          align: "center",
          sortable: true,
          value: "created_at",
        },
        {
          text: "Cliente",
          align: "center",
          sortable: false,
          value: "user.nombre_completo",
          width: "150px",
        },
        {
          text: "Repartidor",
          align: "center",
          sortable: true,
          value: "repartidor.nombre_completo",
        },
        {
          text: "Subtotal",
          align: "right",
          sortable: false,
          value: "subtotal",
        },
        {
          text: "Envío",
          align: "right",
          sortable: false,
          value: "envio",
        },
        {
          text: "Total",
          align: "right",
          sortable: false,
          value: "total",
        },
        {
          text: "Pagado",
          align: "right",
          sortable: false,
          value: "pagado",
        },
        {
          text: "Recompensas",
          align: "right",
          sortable: false,
          value: "total_recompensas",
        },
        {
          text: "Etiquetas",
          align: "left",
          sortable: false,
          value: "tags",
        },

        // {
        //     text: 'Recompensa',
        //     align: 'right',
        //     sortable: false,
        //     value: 'monto_recompensa'
        // },

        // {
        //     text: 'Actualizado',
        //     align: 'center',
        //     sortable: true,
        //     value: 'updated_at'
        // },

        /*{
                        text: 'Opciones',
                        value: 'actions',
                        sortable: false,
                        width: '200px'
                    }*/
      ],
      loading: false,
      pedidos: [],
      repartidores: [],
      repartidor_id: null,
      pedidosTotal: 0,
      options: {
        descending: true,
        page: 1,
        itemsPerPage: this.$root.OPTIONS_PER_PAGE_DATATABLE[0],
        totalItems: 0,
      },
      itemsPerPageOptions: this.$root.OPTIONS_PER_PAGE_DATATABLE,
      pedido_selected: { pagos: [] },
      dialogPayments: false,
      pedidosTotalGlobal: 0,
      montoSubtotalGlobal: 0,
      montoTotalGlobal: 0,
      montoTotalEnvioGlobal: 0,
      montoTotalPagadoGlobal: 0,
    };
  },
  computed: {
    montoSubtotalPorPagina() {
      if (this.pedidos.length) {
        return this.pedidos
          .map((pedido) => pedido.subtotal)
          .reduce((a, b) => a + b, 0);
      }
      return 0;
    },
    montoTotalPorPagina() {
      return this.pedidos.reduce((total, pedido) => {
        return pedido.total ? total + parseFloat(pedido.total) : total;
      }, 0);
    },
    montoTotalPagadoPorPagina() {
      if (this.pedidos.length) {
        return this.pedidos
          .map((pedido) => pedido.pagado)
          .reduce((a, b) => a + b, 0);
      }
      return 0;
    },
    montoTotalEnvioPagina() {
      if (this.pedidos.length) {
        return this.pedidos
          .filter((pedido) => pedido.envio)
          .map((pedido) => pedido.envio)
          .reduce((a, b) => a + b, 0);
      }
      return 0;
    },
    montoTotalRecompensaPagina() {
      return this.pedidos.reduce((total, pedido) => {
        return pedido.monto_recompensa
          ? total + parseFloat(pedido.monto_recompensa)
          : total;
      }, 0);
    },
  },
  methods: {
    formatUpdateAt(fecha) {
      const fechaMoment = moment(fecha);

      return fechaMoment.fromNow();
    },
    listar() {
      if (this.loading === false) {
        let url = "/api/reportes/ventas";
        if (this.filter.export) {
          url = `${url}/export`;
        }
        this.loading = true;
        const { sortBy, sortDesc, page, itemsPerPage } = this.options;
        axios
          .get(url, {
            params: {
              sortBy: sortBy,
              sortDesc: sortDesc,
              page: page,
              rowsPerPage: itemsPerPage,
              search: this.search,
              ...this.filter,
            },
          })
          .then(({ data, request }) => {
            this.loading = false;
            if (this.filter.export) {
              const win = window.open(request.responseURL, "_blank");
              win.focus();
              this.$emit("export-file");
              return;
            }
            this.pedidos = data.data.map((pedido) => {
              if (pedido.pagos.length) {
                pedido.pagado = pedido.pagos
                  .map((pago) => pago.monto)
                  .reduce((a, b) => a + b);
              }
              if (pedido.envios.length) {
                pedido.envio = pedido.envios
                  .map((envio) => Number.parseFloat(envio.pivot.monto))
                  .reduce((a, b) => a + b);
              }
              if (pedido.pedido_detalles.length) {
                pedido.subtotal = pedido.pedido_detalles
                  .map((detalle) => detalle.importe)
                  .reduce((a, b) => a + b);
              }
              if (pedido.recompensas.length) {
                pedido.total_recompensas = pedido.recompensas
                  .map((recompensa) => recompensa.monto_recompensa)
                  .reduce((a, b) => a + b);
              }
              return pedido;
            });
            this.pedidosTotal = data.meta.total;
            this.options.page = data.meta.current_page;
            this.montoSubtotalGlobal = data.subtotal;
            this.montoTotalGlobal = data.total;
            this.montoTotalEnvioGlobal = data.envios;
            this.montoTotalPagadoGlobal = data.pagos;
          });
      }
    },
    assignPerPageOptions(highest) {
      this.itemsPerPageOptions = this.$root.OPTIONS_PER_PAGE_DATATABLE.filter(
        (item) => {
          return item < highest;
        }
      );
      this.itemsPerPageOptions.push(highest);
    },
    showPayments(pedido) {
      this.pedido_selected = pedido;
      this.dialogPayments = true;
    },
  },
  watch: {
    filter: {
      handler: "listar",
      deep: true,
      inmediate: true,
    },
  },
};
</script>

<style scoped>
</style>
